import styled from "styled-components";
import Button from "../../actions/Button";

import { StyledCarouselArrowProps } from "./CarouselArrow.types";

export const StyledCarouselArrow = styled(
	({ direction, slidesToShow, ...props }: StyledCarouselArrowProps) => (
		<Button {...props} />
	)
)<StyledCarouselArrowProps>`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	z-index: 10;
	opacity: ${({ slidesToShow }) => (slidesToShow > 1 ? 0 : 0.2)};
	transition: opacity 300ms ease-in-out;

	${({ direction, slidesToShow, theme }) => {
		const isMultipleSlides = slidesToShow > 1;
		return {
			left:
				direction === "next" ? "auto" : isMultipleSlides ? 0 : theme.space.sm,
			right:
				direction === "next" ? (isMultipleSlides ? 0 : theme.space.sm) : "auto",
		};
	}}
`;
